import { render, staticRenderFns } from "./activitiesDetail2021gz.vue?vue&type=template&id=4e50840e&scoped=true"
import script from "./activitiesDetail2021gz.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2021gz.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2021gz.vue?vue&type=style&index=0&id=4e50840e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50840e",
  null
  
)

export default component.exports